import HBTooltip from '@honeybook/hbui/dist/components/HBTooltip/HBTooltip';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { isNot } from 'styled-is';
import { flexCenterAll } from '@honeybook/hbui/dist/styles/mixins';
import { TargetContainer } from '@honeybook/hbui/dist/components/HBPopover/HBPopover.styles';
import HBClickable from '@honeybook/hbui/dist/components/HBClickable/HBClickable';

interface Props {
    target?: ReactElement;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    toolTipText?: string;
    iconType?: string;
    isThumbnailExist?: boolean;
}

export const IconThumbnailContainer = ({
    target,
    toolTipText,
    onClick,
    iconType,
    isThumbnailExist
}: Props) => {
    return (
        <IconContainerForThumbnail
            onClick={onClick}
            $iconType={iconType}
            $isThumbnailExist={isThumbnailExist}
            testIdName="icon"
        >
            <HBTooltip placement="top" target={target}>
                {toolTipText}
            </HBTooltip>
        </IconContainerForThumbnail>
    );
};

const IconContainerForThumbnail = styled(HBClickable)<{
    $iconType?: string;
    $isThumbnailExist?: boolean;
}>`
    ${flexCenterAll};
    flex-basis: 100%;
    height: 100%;
    transition: background-color 200ms ease;
    border-radius: ${props =>
        props.$iconType === 'trash' ? '4px 0 0 4px' : '0 4px 4px 0'};

    ${isNot('$isThumbnailExist')`
       border-radius : 4px;
    `};

    &:hover {
        background-color: rgba(0, 0, 0, 0.3);
    }

    && ${TargetContainer} {
        ${flexCenterAll};
        width: 100%;
        height: 100%;
    }
`;
